<div class="w100 flex-row gap-12 align-center wrap" [ngClass]="{'pb-24': paddingBottom()}">
  <span class="headline on-background">
    <!--
      INTERDIT : ne JAMAIS projeter de chips, boutons ou autres éléments
      interactifs dans cette projection par défaut. Le wrapper <span> impose
      le style `.headline on-background` (font-size 24px, font-weight 600)
      qui casse l'apparence des chips et autres composants.
      Pour ajouter des chips/badges à côté du titre : utiliser le slot
      [extras] ci-dessous (<ng-content select="[extras]">).
    -->
    <ng-content></ng-content>
  </span>
  <!-- Slot dédié pour chips, badges, statuts à droite du titre -->
  <div class="header-extras flex-row gap-8 align-center wrap">
    <ng-content select="[extras]"></ng-content>
  </div>
  <div class="flex-row ml-auto gap-12 align-center self-align-start">
    @if (rightElement()) {
      <ng-container *ngTemplateOutlet="rightElement()"></ng-container>
    }
    @if (canDelete()) {
      <vl-delete-button (delete)="delete.emit()"></vl-delete-button>
    }
    @if (canClose()) {
      <mat-icon data-testid="btn-close-dialog" class="cursor-pointer" (click)="close.emit()">close</mat-icon>
    }
  </div>
</div>
